<div class="standard-max-width p-4">
    <div class="mb-4">
        <h1 class="text-3xl font-bold text-900 mb-2">Form Assignments</h1>
        <p class="text-600">Manage form assignments for your organization</p>
    </div>

    <div *ngIf="orgId">
        <app-form-assignments [orgId]="orgId" viewMode="org" />
    </div>
</div>